import React, { useCallback } from 'react';
import { toReal } from '../../utils';

function CourseClassInformation({ courseClass, currentVoucher }) {
    const calcAmounVoucher = useCallback(() => {
        if (currentVoucher) {
            const { amount, percent } = currentVoucher;
            if (Number(amount) > 0) {
                const fixedAmount = Number(courseClass.reference_value) - Number(amount);
                return <>
                <p style={{color: 'green'}}>Desconto ({toReal(Number(amount))})</p>
                <p style={{fontWeight: '600'}}>{toReal(fixedAmount)}</p>
                </>
            } else if (Number(percent) > 0) {
                const fixedAmount = Number(courseClass.reference_value) - (Number(courseClass.reference_value) * (Number(percent) / 100));
                return <>
                <p style={{color: 'green'}}>Desconto ({Number(percent)}%)</p>
                <p style={{fontWeight: '600'}}>{toReal(fixedAmount)}</p>
                </>
            }
        }

        return null;
    }, [currentVoucher])

    return (
        <div className="courseInfoContainer">
            <div className="courseInfoGroup">
                <strong>Turma</strong>
                <p>{courseClass.name}</p>
            </div>
            {/* <div className="courseInfoGroup">
                <strong>Head Trainer</strong>
                <p>{courseClass.head_trainer.name}</p>
            </div> */}
            <div className="courseInfoGroup">
                <strong>Valor da Inscrição</strong>
                <p style={currentVoucher ? {
                textDecoration: 'line-through',
                fontStyle: 'italic',
                color: '#e91e63',
                fontWeight: '600'
                } : {fontWeight: '600'}}>R$ {courseClass.reference_value}</p>
                {calcAmounVoucher()}
            </div>
            {/* <div className="courseInfoGroup">
                <strong>Vagas Esgotadas</strong>
                <p>{courseClass.sold_out ? "Sim" : "Não"}</p>
            </div> */}
        </div>
    );
}

export default CourseClassInformation;